/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_UnknownInputs */

const en_errors_unknown = /** @type {(inputs: Errors_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unknown error occurred. Please try again.`)
};

/**
* | output |
* | --- |
* | "An unknown error occurred. Please try again." |
*
* @param {Errors_UnknownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const errors_unknown = /** @type {((inputs?: Errors_UnknownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_UnknownInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_unknown(inputs)
});